/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { defineCustomElement } from '@tylertech/forge-core';
import { LinearProgressComponent } from './linear-progress';
export * from './linear-progress-constants';
export * from './linear-progress';
export function defineLinearProgressComponent() {
    defineCustomElement(LinearProgressComponent);
}
